<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'API Keys'" subheader="Manage global application API keys">
  <ag-grid-angular
    #keyGrid
    [loading]="isLoading()"
    [rowData]="tableData()"
    [columnDefs]="columnDefs"
    [gridOptions]="tableDef"
  ></ag-grid-angular>
</app-pan-card>

<app-pan-modal #newAPIKeyModal [topLevel]="false" [shouldBodyScroll]="true">
  @let isEditing = !!newApiKey().key;

  <div header>{{ isEditing ? "Edit" : "New" }} API Key</div>

  <div body class="flex flex-col gap-2 max-h-[400px]">
    <app-pan-form-control>
      <app-pan-floating-label>Associated Name</app-pan-floating-label>
      <input panInput type="text" [formField]="newApiKeyForm.owner_name" placeholder="Enter associated name" />
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Associated Email</app-pan-floating-label>
      <input panInput type="email" [formField]="newApiKeyForm.email" placeholder="Enter associated email" />
    </app-pan-form-control>

    @if (newAPIKeyModal.isModalCurrentlyOpen()) {
      <app-user-role-selection class="mt-4 pb-4" [(userRoles)]="newRoles"></app-user-role-selection>
    }
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>

    <app-pan-button panModalClose color="primary" (click)="saveAPIKey()" [disabled]="!isFormValid()">Save API Key</app-pan-button>
  </div>
</app-pan-modal>
